import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(theme => ({ 
  spanStyle: {
  borderTop: '1px solid black',
  width: '3px',
  marginRight: '3px',
  display: 'inline-block',
  verticalAlign: 'middle'
},
componentDivStyle: {
  position: 'relative',
  textAlign: 'center'
}}));


export const LastTemplateModalStyle = ({ isOverLast }) => {
  const classes = useStyles();
   return (
     <div className={classes.componentDivStyle} style={{ backgroundColor: isOverLast ? '#66bb6a' : '' }}>
       <span className={classes.spanStyle}></span>
       Drop at the end
       <span className={classes.spanStyle}></span>
     </div>
   );
 }

 export function findNestedElement(id) {
   return document.getElementById(id)?.children[0]?.children[0];
 }
 export function cleanStyle(dragOverId, nextElement) {
   const dragElement = document.getElementById(dragOverId);

   if (dragElement) {
     dragElement.style.borderTop = '';
     let dragNestedElement = findNestedElement(dragOverId);
     dragNestedElement && (dragNestedElement.style.backgroundColor = '');
   }

   if (nextElement) {
     let nextNestedElement = findNestedElement(nextElement.id || nextElement.queryId);
     nextNestedElement && (nextNestedElement.style.backgroundColor = '');
   }

 }
 
 export function throttle(callbackFunc, limit) {
   let inThrottle;
   return function () {
     const args = arguments;
     const context = this;
     if (!inThrottle) {
       callbackFunc.apply(context, args);
       inThrottle = true;
       setTimeout(() => inThrottle = false, limit);
     }
   }
 }

 export function removeDragElementStyle(draggedId) {
  if (draggedId) {
    let dragNestedElement = findNestedElement(draggedId);
    dragNestedElement && (dragNestedElement.style.backgroundColor = '');
  }
 }

 export function addDragElementStyle(id) {
  if (id) {
    let dragNestedElement = findNestedElement(id);
    dragNestedElement && (dragNestedElement.style.backgroundColor = 'rgba(128,128,128,0.1)');
  }
 }

 export function retainStyleForSeconds(draggedId) {
  if (draggedId) {
    let dragNestedElement = findNestedElement(draggedId);
    dragNestedElement && (dragNestedElement.style.backgroundColor = 'rgba(128,128,128,0.1)');
    setTimeout(() => {
      dragNestedElement && (dragNestedElement.style.backgroundColor = '');
    }, 1000);
  }
 }

 export function scrollController(event) {
  const scrollSpeed = 15;
  const upperBoundary = window.innerHeight * 0.15; // 15% from the top
  const lowerBoundary = window.innerHeight * 0.9;  // 10% from the bottom

  if (event.clientY < upperBoundary) {
    window.scrollBy(0, -scrollSpeed);
  } else if (event.clientY > lowerBoundary) {
    window.scrollBy(0, scrollSpeed);
  }
}
 export function dragOverStyle(nextElement,dragOverId) {
  if (dragOverId) {
    const dragElement = document.getElementById(dragOverId);

    if (dragElement) {
      dragElement.style.borderTop = '3px dotted #43a047';
      let dragNestedElement = findNestedElement(dragOverId);
      dragNestedElement && (dragNestedElement.style.backgroundColor = 'rgba(0,255,0,0.05)');
    }

    if (nextElement) {
      let nextNestedElement = findNestedElement(nextElement.id || nextElement.queryId);
      nextNestedElement && (nextNestedElement.style.backgroundColor = 'rgba(0,255,0,0.05)');
    }
  }
 }